export default __webpack_public_path__ + "static/media/COAM-Icon.58dea0ef.svg";